export default __webpack_public_path__ + "static/media/crowsnest.94d53d12.jpg";